import React, {useRef, useState} from 'react';
import Cropper from 'react-easy-crop';
import styled from 'styled-components';
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import {Slider} from "@mui/material";
import Button from "@mui/material/Button";
import {getCroppedImg} from "./Canvas";
import Tx from "../Tx";
import DialogActions from "@mui/material/DialogActions";

const WrapperStyled = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;

  input {
    cursor: pointer;
    position: absolute;
    opacity: 0;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
  }
`;

const CropWrapperStyled = styled.div`
  height: 610px;
`;

const CropBoxStyled = styled.div`
  height: 510px;
  position: relative;
`;

const UploadProfileImage = ({onImageSelect, disableCrop}) => {
    const inputRef = useRef();
    const [imageBase64, setImageBase64] = useState(null);
    const [showCropDialog, setShowCropDialog] = useState(false);
    const [crop, setCrop] = useState({x: 0, y: 0});
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

    const handleOnChange = async (event) => {
        if (event.target.files && event.target.files.length > 0) {
            const reader = new FileReader();
            reader.readAsDataURL(event.target.files[0]);
            reader.onload = e => {
                setImageBase64(reader.result);
                if (!disableCrop) {
                    setShowCropDialog(true);
                } else {
                    onImageSelect(reader.result);
                }
            };
        }
    };

    const onCropComplete = (croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
    };

    const onCancel = () => {
        setShowCropDialog(false);
    };

    const cropHandle = async () => {
        try {
            const croppedImage = await getCroppedImg(imageBase64, croppedAreaPixels);
            setShowCropDialog(false);
            onImageSelect(croppedImage);
        } catch (e) {
            console.error(e);
        }
    };

    return (
        <WrapperStyled>
            <input
                type="file"
                accept="image/*"
                ref={inputRef}
                onChange={handleOnChange}
            />

            {showCropDialog && (
                <Dialog
                    maxWidth="sm"
                    fullWidth={true}
                    open={!!showCropDialog}
                    onClose={setShowCropDialog}
                >
                    <DialogContent>
                        <CropWrapperStyled>
                            <Slider
                                value={zoom}
                                min={1}
                                max={3}
                                step={0.1}
                                aria-labelledby="Zoom"
                                onChange={(e, zoom) => setZoom(zoom)}
                            />
                            <CropBoxStyled>
                                <Cropper
                                    image={imageBase64}
                                    zoom={zoom}
                                    onZoomChange={setZoom}
                                    crop={crop}
                                    aspect={4 / 4}
                                    onCropChange={setCrop}
                                    onCropComplete={onCropComplete}
                                />
                            </CropBoxStyled>
                            <DialogActions style={{marginTop: 30, paddingRight: 0}}>
                                <Button onClick={onCancel}><Tx>g.cancel</Tx></Button>
                                <Button autoFocus onClick={cropHandle}>
                                    <Tx>g.crop</Tx>
                                </Button>

                            </DialogActions>
                        </CropWrapperStyled>
                    </DialogContent>
                </Dialog>
            )}

        </WrapperStyled>
    );
};

export default UploadProfileImage;
